import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toastError, toastUnauthorized,toastSuccess } from "../../AlertMessage/AlertMessage";
import { BaseUrl } from "../../BaseURL";

export const DashMainCountDataAPI = createAsyncThunk("DashMainCountData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        M_UserID,
        token,
        Flag, 
        handleGetCount,      
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Dashboard/Get_DB_WEB_MainCount_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&M_UserID=${M_UserID}&Flag=${Flag}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastUnauthorized()
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleGetCount(result.data)
                return result.data
            } else {
                toastError(result.message)
                return result
            }
        })
})

const DashMainCountDataSlice = createSlice({
    name: "DashMainCountData",
    initialState: {
        isLoading: false,
        Data: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DashMainCountDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(DashMainCountDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.Data = action.payload;
        });
        builder.addCase(DashMainCountDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.Data = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const DashMainCountGetDataReducer = DashMainCountDataSlice.reducer